import React, { useState, useEffect, useContext } from "react";
import { FaSearch } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import AlertContext from "../../../../Context/Alert/AlertContext";
import { BaseURL } from "../../../../Files/BaseURL";
import { getLastSixChars } from "../../../../Files/UseFunction";

const ResolveTickets = () => {
  const navigate = useNavigate();
  const { showAlert } = useContext(AlertContext);

  // State variables
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [totalTickets, setTotalTickets] = useState(0);

  const fetchTickets = async (page = currentPage) => {
    try {
      setLoading(true);
      const authToken = localStorage.getItem("p@token");
      const response = await fetch(
        `${BaseURL}/api/tickets/resolved?page=${page}&limit=${itemsPerPage}${
          searchTerm ? `&search=${searchTerm}` : ""
        }`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "auth-token": authToken,
          },
        }
      );

      if (!response.ok) {
        showAlert("Error Occurred", "danger");
        return;
      }

      const data = await response.json();
      if (data.success) {
        setTickets(data.newCases);
        setTotalPages(data.pagination.totalPages);
        setTotalTickets(data.pagination.totalTickets);
      } else {
        showAlert(data.message || "Error fetching tickets", "danger");
      }
    } catch (err) {
      console.error(err);
      showAlert(err.message, "danger");
    } finally {
      setLoading(false);
    }
  };

  // Fetch tickets when component mounts or search term changes
  useEffect(() => {
    setCurrentPage(1); // Reset to first page when filters change
    fetchTickets(1);
  }, [searchTerm, itemsPerPage]);

  // Fetch tickets when page changes
  useEffect(() => {
    fetchTickets(currentPage);
  }, [currentPage]);

  // Update search input
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  return (
    <div className="w-[95%] m-auto pb-14 py-6 md:py-10">
      <div className="flex flex-col gap-4 lg:flex-row justify-between font-pop lg:items-center">
        <div className="flex gap-2 md:gap-6 items-center">
          {loading ? (
            <h3 className="text-gray-400 text-sm md:text-lg font-medium">
              Loading tickets...
            </h3>
          ) : (
            <h3 className="text-gray-400 text-sm md:text-lg font-medium">
              Total {totalTickets} Resolved Ticket
              {totalTickets !== 1 ? "s" : ""}
            </h3>
          )}
        </div>
        <div className="flex gap-3 items-center bg-gray-300 rounded-full py-2 px-4">
          <FaSearch className="text-gray-400 text-lg md:text-2xl" />
          <input
            type="text"
            value={searchTerm}
            onChange={handleSearch}
            placeholder="Search..."
            className="bg-transparent text-sm md:text-lg border-none outline-none focus:outline-none focus:border-none active:outline-none"
          />
        </div>
      </div>
      <div className="bg-transparent overflow-x-auto font-pop w-full my-2 md:my-6">
        <table className="w-full overflow-x-scroll font-pop border-spacing-y-4 border-separate">
          <thead>
            <tr>
              <th
                scope="col"
                className="px-2 md:px-6 py-1 md:py-3 text-left font-medium text-gray-500 uppercase"
              >
                ID
              </th>
              <th
                scope="col"
                className="px-2 md:px-6 py-1 md:py-3 text-left font-medium text-gray-500 uppercase"
              >
                Seller
              </th>
              <th
                scope="col"
                className="px-2 md:px-6 py-1 md:py-3 text-left font-medium text-gray-500 uppercase"
              >
                Assigned To
              </th>
              <th
                scope="col"
                className="px-2 md:px-6 py-1 md:py-3 text-left font-medium text-gray-500 uppercase"
              >
                Offer
              </th>
              <th
                scope="col"
                className="px-2 md:px-6 py-1 md:py-3 text-left font-medium text-gray-500 uppercase"
              >
                Status
              </th>
              <th
                scope="col"
                className="px-2 md:px-6 py-1 md:py-3 text-left font-medium text-gray-500 uppercase"
              >
                Buyer
              </th>
              <th
                scope="col"
                className="px-2 md:px-6 py-1 md:py-3 text-left font-medium text-gray-500 uppercase"
              >
                Resolution
              </th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="7" className="text-center py-4">
                  Loading...
                </td>
              </tr>
            ) : tickets?.length === 0 ? (
              <tr>
                
              </tr>
            ) : (
              tickets?.map((item, index) => (
                <tr key={index}>
                  <td className="px-2 md:px-6 rounded-l-2xl font-pop text-sm md:text-base bg-white my-3 py-3 text-left ">
                    <h2 className="font-semibold">
                      #{getLastSixChars(item?._id)}
                    </h2>
                  </td>
                  <td className="px-2 md:px-6 bg-white my-3 text-base md:text-lg font-semibold py-3 text-left w-max">
                    <div className="flex w-max gap-2 items-center">
                      <img
                        src={item?.Offer_id?.Seller?.ProfilePhoto}
                        alt={item?.Offer_id?.Seller?.FirstName}
                        className="w-8 h-8 rounded-full"
                      />
                      <h2 className="font-semibold">
                        {item?.Offer_id?.Seller?.FirstName}{" "}
                        {item?.Offer_id?.Seller?.LastName}
                      </h2>
                    </div>
                  </td>
                  <td className="px-2 md:px-6 font-pop text-sm md:text-base bg-white my-3 py-3 text-left ">
                    <h2 className="font-semibold">
                      {item?.DealBy?.Name ? item?.DealBy?.Name : "Un-Assigned"}
                    </h2>
                  </td>
                  <td className="px-2 md:px-6 bg-white my-3 py-1 md:py-3 font-normal text-left ">
                    <h2 className="w-max">{item?.Offer_id?.Type}</h2>
                  </td>
                  <td className="px-2 md:px-6 bg-white my-3 py-1 md:py-3 text-left font-semibold ">
                    <div
                      className={`py-2 px-4 rounded-lg border-2 w-max font-medium
                                                ${
                                                  item?.Status === "Pending"
                                                    ? "bg-[#3992F2]/10 border-[#3992F2] text-[#3992F2]"
                                                    : item?.Status ===
                                                      "Completed"
                                                    ? "bg-[#F9B754]/10 border-[#F9B754] text-[#F9B754]"
                                                    : "bg-[#EFFBF1] border-[#63D577] text-[#63D577]"
                                                }`}
                    >
                      {item?.Status}
                    </div>
                  </td>
                  <td className="px-2 md:px-6 bg-white my-3 py-1 md:py-3 text-left ">
                    <div className="flex w-max font-medium flex-row gap-2 items-center">
                      <img
                        src={item?.Offer_id?.Buyer?.ProfilePhoto}
                        alt={item?.Offer_id?.Buyer?.FirstName}
                        className="w-8 h-8 rounded-full"
                      />
                      <h2 className="font-semibold">
                        {item?.Offer_id?.Buyer?.FirstName}{" "}
                        {item?.Offer_id?.Buyer?.LastName}
                      </h2>
                    </div>
                  </td>
                  <td className="px-2 md:px-6 bg-white my-3 py-1 md:py-3 font-normal text-left ">
                    <h2 className="w-max">{item?.Resolvation}</h2>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {tickets?.length > 0 && (
        <div className="flex items-center justify-between border-t border-gray-200 px-4 py-3 sm:px-6 mt-4 rounded-lg">
          <div className="flex flex-1 justify-between sm:hidden">
            {/* Mobile view */}
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              className={`relative inline-flex items-center px-4 py-2 text-sm font-semibold ${
                currentPage === 1
                  ? "bg-gray-100 text-gray-400"
                  : "bg-white text-gray-700 hover:bg-gray-50"
              } ring-1 ring-inset ring-gray-300 rounded-md`}
            >
              Previous
            </button>
            <button
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              disabled={currentPage === totalPages}
              className={`relative ml-3 inline-flex items-center px-4 py-2 text-sm font-semibold ${
                currentPage === totalPages
                  ? "bg-gray-100 text-gray-400"
                  : "bg-white text-gray-700 hover:bg-gray-50"
              } ring-1 ring-inset ring-gray-300 rounded-md`}
            >
              Next
            </button>
          </div>

          {/* Desktop view */}
          <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
            {/* Left side - Items per page */}
            <div>
              <div className="flex items-center gap-4 font-bold font-pop text-xs">
                <select
                  value={itemsPerPage}
                  onChange={(e) => setItemsPerPage(Number(e.target.value))}
                  className="block w-20 rounded-md border-0 py-1.5 pl-3 pr-8 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-primarygreen sm:text-sm sm:leading-6"
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
                <p className="text-sm text-gray-700">items per page</p>
              </div>
            </div>

            {/* Center - Items count */}
            <div className="font-pop text-xs font-bold">
              <p className="text-sm text-gray-700">
                {`${(currentPage - 1) * itemsPerPage + 1}-${Math.min(
                  currentPage * itemsPerPage,
                  totalTickets
                )} of ${totalTickets} items`}
              </p>
            </div>

            {/* Right side - Navigation and pages */}
            <div className="flex items-center gap-4 font-bold font-pop text-xs">
              <div className="flex items-center gap-2">
                <p className="text-sm text-gray-700">Page</p>
                <p className="text-sm font-bold text-gray-900">{currentPage}</p>
                <p className="text-sm text-gray-700">of</p>
                <p className="text-sm font-bold text-gray-900">{totalPages}</p>
                <p className="text-sm text-gray-700">pages</p>
              </div>
              <nav
                className="isolate inline-flex -space-x-px rounded-md shadow-sm"
                aria-label="Pagination"
              >
                <button
                  onClick={() =>
                    setCurrentPage((prev) => Math.max(prev - 1, 1))
                  }
                  disabled={currentPage === 1}
                  className={`relative inline-flex items-center rounded-l-md px-2 py-2 ${
                    currentPage === 1
                      ? "bg-gray-100 text-gray-400"
                      : "bg-white text-gray-500 hover:bg-gray-50"
                  } ring-1 ring-inset ring-gray-300 focus:z-20 focus:outline-offset-0`}
                >
                  <span className="sr-only">Previous</span>
                  <svg
                    className="h-5 w-5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      fillRule="evenodd"
                      d="M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z"
                      clipRule="evenodd"
                    />
                  </svg>
                </button>

                <button
                  onClick={() =>
                    setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                  }
                  disabled={currentPage === totalPages}
                  className={`relative inline-flex items-center rounded-r-md px-2 py-2 ${
                    currentPage === totalPages
                      ? "bg-gray-100 text-gray-400"
                      : "bg-white text-gray-500 hover:bg-gray-50"
                  } ring-1 ring-inset ring-gray-300 focus:z-20 focus:outline-offset-0`}
                >
                  <span className="sr-only">Next</span>
                  <svg
                    className="h-5 w-5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      fillRule="evenodd"
                      d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
                      clipRule="evenodd"
                    />
                  </svg>
                </button>
              </nav>

              {/* Pages display */}
            </div>
          </div>
        </div>
      )}
      {tickets.length === 0 && (
        <div className="text-center py-4 font-pop text-lg font-medium">
          No resolved ticket found
        </div>
      )}
    </div>
  );
};

export default ResolveTickets;
